import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <App />
);

// Service worker is registered in public/index.html (/service-worker.js)
// It enables offline support: API calls are never cached; pages are network-first.
